import axios from 'axios';

export const getAllContainers = async () => {
  try {
    return axios.get('/modules/media/containers');
  } catch (error) {
    console.error(error);
  }
};
